import React from "react";
import "./_dimension-pill.scss";

// ═══════════════════════════════════════════════════════════════════════════
// DimensionPill — which Execution Blueprint dimension an Objective belongs to
// ("Financial", "Customer", "Operations", "People").
//
// ⚠️ BYTE-IDENTICAL IN BOTH REPOS, like `WigLinkChip` and `ObjectiveDetails`.
// `diff` is the test:
//
//   10x-frontend/.../UserPanel/AnnualOkr/_shared/DimensionPill.js
//   10x-coach-frontend/.../CoachPanel/AnnualOkr/_shared/DimensionPill.js
//
// Takes the payload's `dimension` object as-is — `{ key, label, position,
// total }` — and shows `label`. Renders nothing when the field is absent, so a
// payload that doesn't carry it yet simply shows no pill.
//
// ONE COLOUR FOR EVERY DIMENSION, the brand teal, outline style (2026-10-09,
// by instruction) — the same pill the scorecard and the interview board draw.
// ═══════════════════════════════════════════════════════════════════════════

const DimensionPill = ({ dimension }) =>
  dimension?.label ? <span className="aodim">{dimension.label}</span> : null;

export default DimensionPill;
